<template>
  <div class="box">
    <!-- 职位展示 -->
    <div
      class="Service-body firm-clickable"
      v-for="(item, index) in listArr"
      :key="index"
      @click="handelAskForHelp(item)"
    >
      <div class="Select-box" v-if="distinguish == 1">
        <el-checkbox v-model="item.choose"></el-checkbox>
      </div>
      <!-- 状态 -->
      <div
        v-if="distinguish == 1"
        class="status-show"
        :class="
          item.status == '0'
            ? 'listing'
            : item.status == '1'
            ? 'examine'
            : item.status == '2'
            ? 'Lose'
            : item.status == '3'
            ? 'delist'
            : ''
        "
      >
        {{ item.status == "0" ? "上架中" : "" }}
      </div>
      <!-- 图片 -->
      <img class="product-img" src="" alt="" />
      <!-- 公司名 -->
      <p class="product-name">洪驰供应链管理公司logo设计</p>
      <!-- 价格 评分 -->
      <div class="Price-Score">
        <p>￥ 2000</p>
        <div>4.6</div>
      </div>
      <!-- 销量 完成率 ... -->
      <div class="Sales-Volume">
        <p>销量：123</p>
        <p>好评：111</p>
        <p>完成率：100%</p>
      </div>
      <!-- 企业名称 -->
      <div class="firm-name">
        <!-- <div></div> -->
        <img src="../../../../../../assets/imgs/img/logo.png" alt="" />
        <p>河南省XXX科技有限公司</p>
      </div>
      <!-- 保障 -->
      <div class="guarantee">
        <p class="trace">侦迹金</p>
        <p>准</p>
        <p>保</p>
        <p>原</p>
        <p>源</p>
        <p>修</p>
        <p>价</p>
        <!-- 删除按钮 -->
        <div v-if="distinguish != 2"></div>
      </div>
      <!-- 立即沟通 -->
      <div class="communication" v-if="distinguish == 2">
        <p>立即沟通</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listArr: {},
    distinguish: {}, // 1店铺管理中使用，显示选择框与删除按钮   2是帮帮中使用不显示选择框与删除按钮
  },
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 点击模块
    handelAskForHelp(item) {
      this.$emit("handelAskForHelp", item);
    },
  },
};
</script>

<style scoped lang="less">
// 筛选区
.box {
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  .Service-body:hover {
    // border: 1px solid #409eff ;
    box-shadow: 0px 0px 5px 0px rgba(97, 144, 232, 1);
  }
  .Service-body {
    padding: 10px;
    width: 250px;
    min-height: 300px;
    font-size: 14px;
    position: relative;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 10px;
    margin-right: 18px;
    margin-bottom: 18px;
    // border: 1px solid gold;
    // 选择
    .Select-box {
      width: 15px;
      height: 15px;
      margin: auto 0;
      display: flex;
      /deep/.el-checkbox__inner {
        width: 15px;
        height: 15px;
        border: 1px solid #409eff ;
      }
    }
    // 展示状态
    .status-show {
      width: 45px;
      height: 25px;
      position: absolute;
      top: 0;
      right: 0;
    }
    // 上架
    .listing {
      background: rgba(97, 144, 232, 0.2);
      border-radius: 0px 10px 0px 10px;
      font-size: 12px;
      line-height: 25px;
      color: #409eff ;
      text-align: center;
    }
    // 审核
    .examine {
      background-image: url("../../../../../../assets/imgs/shenhezhong@3x.svg");
      background-size: 100% 100%;
    }
    // 审核失败
    .Lose {
      background-image: url("../../../../../../assets/imgs/shenheshibai@3x.svg");
      background-size: 100% 100%;
    }
    //下架
    .delist {
      background-image: url("../../../../../../assets/imgs/xiajia@3x.svg");
      background-size: 100% 100%;
    }
    // 图片
    .product-img {
      width: 100%;
      height: 100px;
      background: #eeeeee;
      margin-top: 10px;
    }
    // 商品名称
    .product-name {
      width: 100%;
      margin-top: 10px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    // 价格评分
    .Price-Score {
      width: 100%;
      height: 20px;
      line-height: 20px;
      display: flex;
      position: relative;
      margin-top: 10px;
      p {
        font-size: 16px;
        color: #fe574a;
      }
      div {
        width: 25px;
        height: 20px;
        background: #fe574a;
        border: 1px solid #fe574a;
        border-radius: 5px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        position: absolute;
        right: 0;
      }
    }
    //销量 好评 完成率
    .Sales-Volume {
      width: 100%;
      height: 14px;
      line-height: 14px;
      font-size: 12px;
      color: #666666;
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
    }
    // 企业名称
    .firm-name {
      display: flex;
      width: 100%;
      height: 25px;
      line-height: 25px;
      margin-top: 30px;
      img {
        width: 25px;
        height: 25px;
      }
      p {
        margin-left: 10px;
        font-size: 14px;
        color: #333333;
      }
    }
    // 保障
    .guarantee {
      width: 100%;
      height: 20px;
      line-height: 20px;
      margin-top: 10px;
      display: flex;
      position: relative;
      // 保障金
      p {
        height: 20px;
        background: #3bb500;
        border-radius: 5px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        font-weight: 400;
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
      .trace {
        width: 50px;
        height: 20px;
        margin-right: 10px;
      }
      //   删除按钮
      div {
        width: 20px;
        height: 20px;
        background-image: url("../../../../../../assets/imgs/shanchu@3x.svg");
        background-size: 100% 100%;
        position: absolute;
        right: 0;
      }
    }
    // 立即沟通
    .communication {
      width: 100%;
      height: 25px;
      line-height: 25px;
      display: flex;
      margin-top: 15px;
      margin-bottom: 5px;
      p {
        width: 91px;
        height: 23px;
        background: rgba(97, 144, 232, 0.2);
        border: 1px solid #409eff ;
        border-radius: 5px;
        font-size: 12px;
        color: #409eff ;
        text-align: center;
        margin: auto;
      }
    }
  }
  .Service-body:nth-child(4) {
    margin-right: 0px;
  }
  .Service-body:nth-child(8) {
    margin-right: 0px;
  }
}
</style>
